<div class="unauthorized-container">
  <div class="unauthorized-content">
    <img src="wealth-assets/svg/expiration.svg" />
    <p class="unauthorized-title">دوباره وارد شوید</p>
    <p class="unauthorized-description">به دلیل مشکلات سرویس‌دهنده برای ادامه فرایند دوباره وارد مدیریت ثروت شوید.</p>
  </div>

  <ngx-button
    class="btn-retry"
    [fullWidth]="true"
    (clickHandler)="goBack()"
    [brandButton]="true"
  >
    متوجه شدم
  </ngx-button>
</div>
